"use client";

import { usePathname, useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";
import Image from "next/image";
import DropdownIcon from "../../atoms/icons/DropdownIcon";
import GlobeIcon from "@/components/atoms/icons/Globe";

const languages = [
  { code: "vi", label: "Tiếng Việt", flag: "/images/img_logo_vi.webp" },
  { code: "en", label: "English", flag: "/images/img_logo_en.webp" },
  { code: "kr", label: "한국어", flag: "/images/img_logo_ko.webp" },
];

const LanguageSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();
  const router = useRouter();
  const { i18n } = useTranslation();
  const popoverRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const switchLanguage = (locale: string) => {
    const segments = pathname.split("/");
    segments[1] = locale;
    router.push(segments.join("/"));
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="md:block hidden relative min-w-fit w-fit" ref={popoverRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200"
      >
        <GlobeIcon />
        <span className="pr-1">{t("language")}</span>
        <DropdownIcon isOpen={isOpen} />
      </button>

      <div
        className={`absolute right-0 z-10 mt-2 w-48 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transform transition-all duration-200 ease-out ${
          isOpen
            ? "opacity-100 scale-100"
            : "opacity-0 scale-95 pointer-events-none"
        }`}
      >
        <div className="py-1">
          {languages.length > 0 ? (
            languages.map((language) => (
              <button
                key={language.code}
                onClick={() => switchLanguage(language.code)}
                className={`flex w-full items-center px-4 py-2 text-sm hover:bg-gray-100 transition-colors duration-200
                  ${i18n.language === language.code ? "bg-gray-200" : ""}`}
              >
                <Image
                  src={language.flag}
                  alt=""
                  width={20}
                  height={20}
                  className="mr-2"
                />
                <span>{language.label}</span>
              </button>
            ))
          ) : (
            <div className="px-4 py-2 text-sm text-gray-500">
              {t("no_languages_available")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
